"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Chrome_1 = __importDefault(require("../IconsSystems/Chrome"));
const styled_1 = require("./styled");
const ChromeDownload = ({ height = "auto", width = "100%", }) => (react_1.default.createElement(styled_1.IconWrapper, { height: height, width: width },
    react_1.default.createElement(Chrome_1.default, { size: 48 }),
    react_1.default.createElement("span", null, "Add to Chrome")));
exports.default = ChromeDownload;
//# sourceMappingURL=ChromeDownload.js.map